import './RemoveFavorite.scss'
import React from 'react'

const RemoveFavorite = () => {
    return (
        <div className="remove-favorite">
            <i className="far fa-trash-alt">
            </i>
        </div>
    )
}

export default RemoveFavorite
